import { Button, DatePicker, Drawer, Form, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { assignAsset } from "../../../redux/rtk/features/assets/assetsSlice";
import { loadAllStaff } from "../../../redux/rtk/features/user/userSlice";


const AssignAssetPopup = ({ assetData }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const users = useSelector((state) => state.users?.list);

    useEffect(() => {
        dispatch(loadAllStaff({ status: true }));
    }, []);
    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onFinish = async (values) => {
        // console.log(values);

        const formData = {
            ...values,
            assignedDate: values.assignedDate ? values.assignedDate.toISOString() : null,
            assetId: assetData.id,
            status: true
        };

        try {
            setLoader(true);
            await dispatch(assignAsset(formData));
			form.resetFields();
            setOpen(false);
        } catch (error) {
            toast.error("Failed to assign asset");
        } finally {
            setLoader(false);
        }
    };

    const onFinishFailed = (errorInfo) => {
        toast.warning("Please complete the required fields");
        setLoader(false);
    };

    return (
        <>
            <Button onClick={showDrawer} type='primary'>
                Assign Asset
            </Button>
            <Drawer
                width={720}
                title='Assign Asset'
                placement='right'
                onClose={onClose}
                open={open}
            >
                <Form
                    form={form}
                    layout='vertical'
                    initialValues={{ assignedDate: dayjs() }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >

                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Assigned To "
                        name="assignedToUserId"
                        rules={[
                            {
                                required: true,
                                message: "Please select a user!",
                            },
                        ]}
                    >
                        <Select
                            placeholder="Assigned To"
                            showSearch
                            allowClear
                        >
                            {users.map(user => (
                                <Select.Option key={user.id} value={user.id}>
                                    {user.firstName} {user.lastName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label='Assigned Date'
                        name='assignedDate'
                        rules={[{ required: true, message: 'Please select the assigned date!' }]}
                    >
                        <DatePicker format={"DD-MM-YYYY"} />
                    </Form.Item>

                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Assigned By "
                        name="assignedByUserId"
                        rules={[
                            {
                                required: true,
                                message: "Please select a user!",
                            },
                        ]}
                    >
                        <Select
                            placeholder="Assigned By "
                            showSearch
                            allowClear
                        >
                            {users.map(user => (
                                <Select.Option key={user.id} value={user.id}>
                                    {user.firstName} {user.lastName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type='primary'
                            htmlType='submit'
                            loading={loader}
                            block
                        >
                            Assign Asset
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>
    );
};

export default AssignAssetPopup;
